export default __webpack_public_path__ + "static/media/Image3.3b859959.png";